<template>
  <card :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveProjectType)">
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="projectAssignmentTypeInput"
              ref="projectAssignmentTypeInput"
              v-model="projectType"
              :name="'projectAssignmentType'"
              variant="static"
              :label="($t('projectTypes.projectAssignmentType') || 'Assignment Type') + ' *'"
              :placeholder="$t('projectTypes.projectAssignmentType') || 'Assignment Type'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button type="submit" variant="gradient" color="dark">
              {{ $t('common.submit') }}
            </material-button>
          </div>
        </div>
      </form>
    </Form>
  </card>
</template>
<script>
import api from "../../services/api";
import { getApiErrorMessage } from "../../utils/apiError";
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  components: {
    Form,
    Card,
    MaterialInputField,
    MaterialButton
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    projectTypeProp: {
      type: String,
      required: false,
      default: ''
    },
    projectTypeId: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
      projectType: this.projectTypeProp,
    };
  },
  computed: {
    computedTitle() {
      return this.editMode
        ? (this.$t('projectTypes.editProjectAssignmentType') || 'Edit Assignment Type')
        : (this.$t('projectTypes.createProjectAssignmentType') || 'Create Assignment Type');
    },
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    cancel() {
      this.$emit('close');
    },
    async saveProjectType() {
      if (!this.validateInput()) return;
      if (this.editMode) {
        try {
          await api.put('/ProjectAssignmentType/' + this.projectTypeId, { type: this.projectType });
          this.$toast.success(this.$t('projectTypes.projectAssignmentTypeUpdated') || 'Assignment type updated', { timeout: 1500 });
          this.$emit('refresh-data');
          this.$emit('close');
        } catch (error) {
          console.error(error); // eslint-disable-line no-console
          this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
        }
      } else {
        try {
          await api.post('/ProjectAssignmentType', { type: this.projectType });
          this.$toast.success(this.$t('projectTypes.projectAssignmentTypeCreated') || 'Assignment type created', { timeout: 1500 });
          this.$emit('refresh-data');
          this.$emit('close');
        } catch (error) {
          console.error(error); // eslint-disable-line no-console
          this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
        }
      }
    },
    validateInput() {
      if (!this.projectType) {
        this.$toast.info(this.$t('errors.newProjectTypeEmpty'), { timeout: 2500 });
        return false;
      }
      return true;
    }
  },
};
</script>
